import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

// Barra e menu: mesmo tratamento para Ar-Condicionado e Painéis Solares (páginas do site público).
const NAV = [
  { label: 'Home', href: '/', isHash: false },
  { label: 'Ar-Condicionado', href: '/ar-condicionado', isHash: false },
  { label: 'Painéis Solares', href: '/paineis-solares', isHash: false },
  { label: 'Serviços', href: '/servicos', isHash: false },
  { label: 'Contactos', href: '/contactos', isHash: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#ffffff]" style={{ backgroundColor: '#ffffff' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 lg:h-20">
        <Link
          to="/"
          className="flex items-center"
          onClick={() => setOpen(false)}
          aria-label="Ir para a página inicial"
        >
          <img
            src={`${process.env.PUBLIC_URL || ''}/logo-electrosalir.png`}
            alt="Electrosalir Lda"
            className="h-12 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="Navegação principal">
          {NAV.map((item) => (
            item.isHash ? (
              <a key={item.href} href={item.href} className="text-slate-600 hover:text-gestao-primary font-medium transition-colors">
                {item.label}
              </a>
            ) : (
              <Link
                key={item.href}
                to={item.href}
                className="text-slate-600 hover:text-gestao-primary font-medium transition-colors"
                data-site-nav={item.label === 'Painéis Solares' ? 'paineis-solares' : undefined}
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>

        <button
          type="button"
          className="md:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg"
          onClick={() => setOpen(!open)}
          aria-label={open ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-[#ffffff] px-4 py-4 flex flex-col gap-3 overflow-y-auto max-h-[70vh]" role="navigation" aria-label="Menu telemóvel">
          {NAV.map((item) => (
            item.isHash ? (
              <a key={item.href} href={item.href} className="text-slate-700 hover:text-gestao-primary font-medium py-2 block" onClick={() => setOpen(false)}>
                {item.label}
              </a>
            ) : (
              <Link
                key={item.href}
                to={item.href}
                className="text-slate-700 hover:text-gestao-primary font-medium py-2 block"
                onClick={() => setOpen(false)}
                data-site-nav={item.label === 'Painéis Solares' ? 'paineis-solares' : undefined}
              >
                {item.label}
              </Link>
            )
          ))}
        </div>
      )}
    </header>
  );
}
